import React from 'react'
import './ProjectsSection.scss'

import projects from '../../assets/home/projects.png'

interface ProjectsSectionProps {

}

const ProjectsSection: React.FC<ProjectsSectionProps> = ({ }) => {
  return (
    <div className='ProjectsSection'>
        <div className="container projectsSection">
            <div className="col-12 col-md-6 image-container">
                <img className='project-image' src={projects} alt="" />
            </div>
            <div className="col-12 col-md-6 info-block">
                <div className="title">Projects we made</div>
                <div className="desc">
                    There are projects that we made. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras placerat malesuada est sit amet eleifend. 
                </div>
                <a href='/portfolio' className="button primary-button see-all">See projects</a>
            </div>
        </div>
    </div>
  )
}

export default ProjectsSection